export default function menuOpen() {
    const burgerButtons = document.querySelectorAll('.js-menu-toggle');
    const panel = document.querySelector('.taohs-menu-panel');
    const headerTop = document.querySelector('.taohs-head-top');
    if (!burgerButtons.length) {
        return;
    }

    const syncMenuOffset = () => {
        if (!panel || !headerTop) {
            return;
        }
        const bottom = headerTop.getBoundingClientRect().bottom;
        panel.style.top = `${Math.max(bottom, 0)}px`;
    };

    const setOpen = (open) => {
        document.body.classList.toggle('gh-head-open', open);
        if (panel) {
            panel.hidden = !open;
        }
        burgerButtons.forEach((button) => {
            if (!button.classList.contains('taohs-menu-btn')) {
                return;
            }
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
            button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
            const label = button.querySelector('.js-menu-label');
            if (label) {
                label.textContent = open ? 'Close' : 'Menu';
            }
        });
        if (open) {
            syncMenuOffset();
        }
    };

    burgerButtons.forEach((button) => {
        button.addEventListener('click', () => {
            setOpen(!document.body.classList.contains('gh-head-open'));
        });
    });

    panel?.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
                return;
            }
            const dest = new URL(link.href, window.location.href);
            if (dest.origin !== window.location.origin) {
                setOpen(false);
                return;
            }
            if (dest.pathname === window.location.pathname) {
                setOpen(false);
            }
        });
    });

    window.addEventListener('resize', () => {
        if (document.body.classList.contains('gh-head-open')) {
            syncMenuOffset();
        }
    });

    const groups = [...document.querySelectorAll('.taohs-menu-franchise')];
    groups.forEach((group) => {
        const toggle = group.querySelector('.taohs-menu-toggle');
        const list = group.querySelector('ul');
        toggle?.addEventListener('click', (event) => {
            event.preventDefault();
            const willOpen = !group.classList.contains('is-open');
            groups.forEach((other) => {
                other.classList.remove('is-open');
                const otherList = other.querySelector('ul');
                const otherToggle = other.querySelector('.taohs-menu-toggle');
                if (otherList) {
                    otherList.hidden = true;
                }
                otherToggle?.setAttribute('aria-expanded', 'false');
            });
            if (willOpen) {
                group.classList.add('is-open');
                if (list) {
                    list.hidden = false;
                }
                toggle.setAttribute('aria-expanded', 'true');
            }
        });
    });
}
